import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { RecordAction } from "../../../../../utils/enums/shared/enums";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { UploadFileHistoryService } from "../../../../../services/groups/upload-file-history.service";
import { UploadFileHistoryDataSource } from "../../../../../utils/datasources/groups/upload-file-history.datasource";
import { DatatableComponent } from "@siemens/ngx-datatable";
import { Pagination } from "../../../../../utils/types/shared/pagination";
import { SharedMapper } from "../../../../shared/shared.mapper";
import { UploadFileHistoryMapper } from "../../../../../utils/mappers/groups/upload-file-history.mapper";
import { UploadFileHistory } from "../../../../../utils/interfaces/upload-file-history/upload-file-history.interface";

@Component({
    selector: "app-upload-file-history",
    templateUrl: "./upload-file-history.component.html",
    styleUrl: "./upload-file-history.component.scss",
    providers: [UploadFileHistoryService],
})
export class UploadFileHistoryComponent {
    @ViewChild("myDataTable") datable: DatatableComponent;

    public action: RecordAction = RecordAction.View;
    public dialogTitle: string = "";
    public page: Pagination = new Pagination();
    public rows: UploadFileHistory[] = [];
    public isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        public dialogRef: MatDialogRef<UploadFileHistoryComponent>,
        private translateService: TranslateService,
        private uploadFileHistoryService: UploadFileHistoryService
    ) {}

    ngOnInit() {
        this.dialogTitle = this.translateService.instant("log-history");
        this.getUploadFileHistory();
    }

    onResize(entry: ResizeObserverEntry[]) {
        this.datable.recalculate();
    }

    paginate(event: any) {}

    private getUploadFileHistory() {
        this.isLoading = true;
        this.uploadFileHistoryService
            .getUploadFileHistory(this.data.grupo.id)
            .subscribe((res) => {
                this.rows = res.map((row: UploadFileHistory) => {
                    return {
                        ...row,
                        status:
                            row.status === 1
                                ? this.translateService.instant("Finished")
                                : this.translateService.instant("In proccess"),
                        file: row.file.split("/")[1],
                    } as UploadFileHistory;
                });
                this.isLoading = false;
            });
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
